import React from "react";
import { Grid, Paper } from "@mui/material";
import { formatDate } from "hooks";
import InquiryStatusWidget from "./InquiryStatusWidget";

const InqDetails = ({ values }) => {
  return (
    <Paper className="pt-[5px]">
      {values && (
        <Grid container spacing={3} className="p-[15px] mb-[10px]">
          <Grid item xs={12} md={2} className="grid">
            <span className="text-[12px] uppercase mb-[5px] text-gray-500">
              Status
            </span>
            <InquiryStatusWidget status={values.status} />
          </Grid>
          <Grid item xs={12} md={3} className="grid">
            <span className="text-[12px] uppercase mb-[5px] text-gray-500">
              Inquiry Id:
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {values.id}
            </span>
          </Grid>
          <Grid item xs={12} md={3} className="grid">
            <span className="text-[12px] uppercase mb-[5px] text-gray-500">
              Full Name:
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {values.fullName}
            </span>
          </Grid>
          <Grid item xs={12} md={3} className="d-grid">
            <span className="text-[12px] uppercase mb-[5px] text-gray-500">
              Mobile:
            </span>
            <a
              className="link text-[16px] font-medium text-gray-500"
              href={`tel:${values.phone}`}
            >
              {values.phone}
            </a>
          </Grid>
          {values.inuirySourceId && (
            <Grid item xs={12} md={3} className="grid">
              <span className="text-[12px] uppercase mb-[5px] text-gray-500">
                Source Of Inquiry:
              </span>
              <span className="text-[16px] font-medium text-gray-500">
                {values.InquerySource && values.InquerySource?.name}
              </span>
            </Grid>
          )}

          <Grid item xs={12} md={3} className="grid">
            <span className="text-[12px] uppercase mb-[5px] text-gray-500">
              Email
            </span>
            <a
              className="link text-[16px] font-medium text-gray-500"
              href={`mailto:${values.email}`}
            >
              {values.email}
            </a>
          </Grid>
          <Grid item xs={12} md={3} className="grid">
            <span className="text-[12px] uppercase mb-[5px] text-gray-500">
              Inquiry Date:
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {formatDate(values.inqDate)}
            </span>
          </Grid>
          {values.remark && (
            <Grid item xs={12} className="grid">
              <span className="text-[12px] uppercase mb-[5px] text-gray-500">
                Remark:
              </span>
              <span className="text-[16px] font-medium text-gray-500">
                {values.remark}
              </span>
            </Grid>
          )}
        </Grid>
      )}
    </Paper>
  );
};

export default InqDetails;
